import { useContext } from "react";
import { CreateNFeContext } from "../../../../../Context";

export function useChangeDiscountValue() {
  const NFeContext = useContext(CreateNFeContext);

  const setDiscountValue = (inputEvent) => {
    const { value } = inputEvent;
    const { nfe } = NFeContext;
    const { total_items, total_nfe, total_paid } = nfe;
    const { setPaidValue, updateNFeData, updateTotalNFe } = NFeContext.handlers;

    if (value >= total_items) {
      nfe.identification.discount_value = total_items;
      setPaidValue(0);
      return;
    }
    nfe.identification.discount_value = value
    const left = total_nfe - (total_paid + value);
    setPaidValue(left);
    updateNFeData(nfe)
    updateTotalNFe()
  };
  return setDiscountValue;
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/Discount/hooks/index.js